import { Box, Skeleton, Typography, useTheme } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { formatNumberWithOptions } from "@outschool/time";
import { pxToRem } from "@outschool/ui-utils";
import React from "react";

function ResultsCount({
  exactTotal,
  andMore,
  loading
}: {
  exactTotal: number;
  andMore: boolean;
  loading: boolean;
}) {
  const { t } = useTranslation("client\\components\\search\\ResultsCount");

  const { breakpoints } = useTheme();

  if (!exactTotal) {
    return null;
  }

  return (
    <Box
      flex
      sx={{
        marginY: "1.5em",
        justifyContent: "center",
        [breakpoints.down("md")]: {
          marginY: 0,
          paddingY: "0.5em",
          borderBottom: "1px solid lightgray",
          borderTop: "1px solid lightgray",
          borderColor: "grey.200",
          backgroundColor: "grey.50"
        }
      }}
    >
      <Typography variant="subtitle1">
        {loading ? (
          <Skeleton width={pxToRem(265)} />
        ) : (
          t("{{number}}{{plus}} class matches your search", {
            number: formatNumberWithOptions(exactTotal, {
              style: "decimal",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }),
            count: exactTotal + (andMore ? 2 : 0),
            defaultValue_plural: "{{number}}{{plus}} classes match your search",
            plus: andMore ? "+" : ""
          })
        )}
      </Typography>
    </Box>
  );
}

export default ResultsCount;
